import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "../pages/Login/Login";
import Dashboard from "../pages/Dashboard/Dashboard";
import OutletsList from "../pages/Outlets/OutletsList";
import MediaUpload from "../pages/Media/MediaUpload";
import ProtectedLayout from "../components/ProtectedLayout";
import MediaList from "../pages/Media/MediaList";
import PlaylistPage from "../pages/Playlist/PlaylistPage";
import SchedulePage from "../pages/Schedule/SchedulePage";
// import ControlPanel from "../pages/RemoteControl/ControlPanel";
import MusicControlPage from "../pages/RemoteControl/MusicControlPage";
import AdminStreamControl from "../pages/AdminStreamControl/AdminStreamControl";

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<Login />} />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedLayout>
              <Dashboard />
            </ProtectedLayout>
          }
        />

        <Route
          path="/outlets"
          element={
            <ProtectedLayout>
              <OutletsList />
            </ProtectedLayout>
          }
        />

        <Route
          path="/media"
          element={
            <ProtectedLayout>
              <MediaUpload />
            </ProtectedLayout>
          }
        />
        <Route
          path="/list"
          element={
            <ProtectedLayout>
              <MediaList />
            </ProtectedLayout>
          }
        />
        <Route
          path="/playlist"
          element={
            <ProtectedLayout>
              <PlaylistPage />
            </ProtectedLayout>
          }
        />
        <Route
          path="/schedule"
          element={
            <ProtectedLayout>
              <SchedulePage />
            </ProtectedLayout>
          }
        />
        <Route
          path="/Status"
          element={
            <ProtectedLayout>
              <MusicControlPage/>
            </ProtectedLayout>
          }
        />
        <Route path="/admin/stream" element={<ProtectedLayout><AdminStreamControl/></ProtectedLayout>} />

      </Routes>
    </BrowserRouter>
  );
}
